module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "my-org"
  }, [_c('div', {
    staticClass: "step1"
  }, [_c('div', {
    staticClass: "org-detail"
  }, [(_vm.status == 0) ? _c('Entdetail', {
    attrs: {
      "dataEnt": _vm.dataEnt
    }
  }) : _vm._e(), _vm._v(" "), (_vm.status == 1) ? _c('Govdetail', {
    attrs: {
      "dataGov": _vm.dataGov
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14db853a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/weather/confirmInfo.vue
// module id = 1180
// module chunks = 2